import { useCallback } from 'react';

import SalonModal from 'components/dialog/SalonModal.component';
import SM from 'components/dialog/SalonModal.module.scss';
import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import IconStatus from 'components/generic/IconStatus.component';
import Space from 'components/generic/Space.component';
import CurrencySign from 'components/price/CurrencySign.component';
import DEPOSIT_SOURCE from 'constants/payment/depositSource.const';
import { useTranslation } from 'providers/GILT.provider';
import pageScrollToTop from 'utils/dom/pageScrollToTop.util';
import call from 'utils/functions/call.util';

export const LockedRefundDialog = ({ value, source, onClose, onConfirm }) => {
  const { t } = useTranslation();

  const handleConfirm = useCallback(() => {
    call('LockedRefundDialog.onConfirm', onConfirm);
    call('LockedRefundDialog.onClose', onClose);
    pageScrollToTop();
  }, [onConfirm, onClose]);

  pageScrollToTop();

  return (
    <SalonModal tag="LockedRefundDialog" isOpen>
      <SalonModal.Header>
        <div className={SM.closeButtonContainer}>
          <Button variant="empty" onClick={onClose}>
            <Icon variant="close" variantInvert />
          </Button>
        </div>
      </SalonModal.Header>
      <SalonModal.Body>
        <IconStatus variant="alert" width="lg">
          <Icon variant="alert" width="l1" />
        </IconStatus>
        <div className={SM.modalContent}>
          <div className={SM.modalTitle}>{t('balanceSheet.refundDialog.title')}</div>
          <div className={SM.modalText}>
            {t('balanceSheet.refundDialog.descriptionPart1')}

            <Space bold>
              <CurrencySign value={value} />
            </Space>

            {source === DEPOSIT_SOURCE.card && t('balanceSheet.refundDialog.descriptionPart2')}
            {(source === DEPOSIT_SOURCE.cash || source === DEPOSIT_SOURCE.online) && t('balanceSheet.refundDialog.descriptionPart3')}
            {source === DEPOSIT_SOURCE.other && t('balanceSheet.refundDialog.descriptionPart4')}
          </div>
          <div className={SM.modalText}>{t('balanceSheet.refundDialog.guideText')}</div>
        </div>
      </SalonModal.Body>
      <SalonModal.Footer>
        <div className={SM.modalButtons}>
          <Button variant="outlineForce" onClick={onClose}>
            {t('common.buttons.cancelUpp')}
          </Button>
          <Button variant="primaryForce" onClick={handleConfirm}>
            {t('common.buttons.confirmUpp')}
          </Button>
        </div>
      </SalonModal.Footer>
    </SalonModal>
  );
};
